import { CurrentCycleWindow } from '../../interfaces/current-cycle-window/current-cycle-window';

export abstract class AbstractCycleDateWindowService {
  abstract getCurrentCycleDateWindow(): Promise<CurrentCycleWindow | undefined>;
}
